import { withStyles, withTheme } from '@material-ui/core/styles';
import { Paper, Divider } from '@material-ui/core';
import { compose } from 'recompose';

const styles = (theme) => ({
  outerMostWrapper: {
    zIndex: 2,
    position: 'absolute',
    pointerEvents: 'auto',
    bottom: 0,
    left: 5,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.ModalBGColor
  },
  legendHeader: {
    color: theme.HeaderSelectedText,
    fontSize: '14px',
    height: 25,
    padding: 10,
    fontWeight: 600,
    textAlign: 'left',
    display: 'flex'
  },
  legendDetailsContainer: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: 1
  },
  details: {
    display: 'flex',
    alignItems: 'end',
    columnGap: 5,
    padding: "4px 10px",
    width: 125
  },
  detailsLabel: {
    color: theme.ModalHeaderTextColor,
    fontSize: 10,
    marginLeft: 5,
    marginRight: 5,
    whiteSpace: 'nowrap'
  },
  iconContainer: {
    width: 24,
    marginLeft: -2
  },
  divider: {
    background: theme.gridIconBorderColor,
    height: 0.5
  }
});

const MapLegend = ({ 
  classes, 
  theme, 
  isEnabled,
  legendItems,
  renderIcon,
  title = 'Map Legend'
}) => {
  if (!isEnabled || !legendItems?.length) return null;

  return (
    <Paper className={classes.outerMostWrapper}>
      <div>
        <div id="legendHeader" className={classes.legendHeader}>
          {title}
        </div>
        <Divider className={classes.divider} />
        <div id="legendDetails" className={classes.legendDetailsContainer}>
          {legendItems.map((item) => (
            <div key={item.key || item.id} className={classes.details}>
              <div className={classes.iconContainer}>
                {item.icon || renderIcon({
                  item,
                  theme,
                  ...item
                })}
              </div>
              <div className={classes.detailsLabel}>{item.label}</div>
            </div>
          ))}
        </div>
      </div>
    </Paper>
  );
};

export default compose(withStyles(styles), withTheme())(MapLegend);
